import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'pill': 'pillClick', 'apply' : 'applyFilters' } };
        this.filters = [...this.$( 'filter' )];
        this.rooms = [...document.querySelectorAll( '[data-room]')];
        this.roomsCategories = [...document.querySelectorAll( '[data-rooms-category]')];
        this.quests = this.$( 'guests' )[0];
        this.size = this.$( 'size' )[0];
        this.noResults = this.$( 'no-results' )[0];
        this.end = this.$( 'end' )[0];
        this.header = document.querySelector( 'header' );
    }

    applyFilters(){




        this.rooms.forEach( room => room.classList.add( 'hidden' ) );
        this.roomsCategories.forEach( category => category.classList.add( 'hidden' ) );
        let activeRooms = this.rooms;


        // filter guests
        activeRooms = activeRooms.filter(room => {
            return parseInt( room.dataset.guests ) >= parseInt( this.quests.textContent);
        });

        //filter size
        let sizeArray = this.size.textContent.split( '-').map( s => parseInt( s ) );
        activeRooms = activeRooms.filter(room => {
            let roomSizeFrom = parseInt( room.dataset.sizeFrom );
            let roomSizeTo = room.dataset.sizeTo;
            if( ! roomSizeTo ){
                return roomSizeFrom >= sizeArray[0] && roomSizeFrom <= sizeArray[1];
            } else {
                roomSizeTo = parseInt( room.dataset.sizeTo );
                return this.rangesIntersect( roomSizeFrom, roomSizeTo, sizeArray[0], sizeArray[1])
            }
        });


        this.filters.forEach( filter => {
           let activePills = [...filter.querySelectorAll( '.pill.active' )];
           let filterName = filter.dataset.value;



           if( activePills.length ) {
               let filterQuery = [];
               activePills.forEach( pill => {
                   filterQuery.push( '[data-' + filterName + '-' + pill.dataset.value + ']' );
               });
               let filterActiveRooms = [...document.querySelectorAll( filterQuery.join(',') )];
               activeRooms = activeRooms.filter(item => filterActiveRooms.includes(item));

           }
        });

        this.noResults.classList.toggle( 'hidden', activeRooms.length );
        if( ! activeRooms.length ){
            activeRooms = this.rooms;
        }

        activeRooms.forEach( room => {
            room.classList.remove( 'hidden' );
            room.closest( '[data-rooms-category]' ).classList.remove( 'hidden' );
        } );
        this.call( 'update', false, 'Swipper' );
        this.call('scrollTo', { target : this.end, options: { offset: -this.header.offsetHeight } },  'Scroll');

    }

    rangesIntersect(start1, end1, start2, end2) {
        if (start1 <= start2 && start2 <= end1 || start1 <= end2 && end2 <= end1) {
            return true;
        } else if (start2 <= start1 && start1 <= end2 || start2 <= end1 && end1 <= end2) {
            return true;
        } else {
            return false;
        }
    }

    pillClick( e ){
        let el = e.currentTarget;
        el.classList.toggle( 'active' );
    }
    init() {}
    destroy(){}
}
